import { render } from "./Home.vue?vue&type=template&id=394a2d1a&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=394a2d1a&lang=scss&scoped=true"

import exportComponent from "/Users/tobias/Projects/MontyBuy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394a2d1a"]])

export default __exports__